export enum ResumeType {
    WEB = 1,
    PDF = 2
}